import { render, staticRenderFns } from "./diario.vue?vue&type=template&id=5ea08c2d"
import script from "./diario.vue?vue&type=script&lang=js"
export * from "./diario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports